export const dataOperatorAll = [
  {
    'label': "Equal",
    'value': "==",
    'question_type': ['NUM_0', 'SIN_0', 'MUL_0']
  },
  {
    'label': "Not Equal",
    'value': "!=",
    'question_type': ['NUM_0', 'SIN_0', 'MUL_0']
  },
  {
    'label': "More Than",
    'value': ">",
    'question_type': ['NUM_0']
  },
  {
    'label': "More Than Equal",
    'value': ">=",
    'question_type': ['NUM_0']
  },
  {
    'label': "Less Than",
    'value': "<",
    'question_type': ['NUM_0']
  },
  {
    'label': "Less Than Equal",
    'value': "<=",
    'question_type': ['NUM_0']
  },
  // etc
]

export const dataUrbanity = [
  { label: "Urban", value: "Urban" },
  { label: "Rural", value: "Rural" },
];

export const dataStatModules = [
  { label: "Setup Panel", value: "setup-panel" },
  { label: "Setup Category", value: "setup-category" },
  { label: "Setup Store Type", value: "setup-store-type" },
  { label: "Setup Store Type Stat", value: "setup-store-type-stat" },
  { label: "Setup Store Type Mapping", value: "setup-store-type-mapping" },
  { label: "Setup Cell", value: "setup-cell" },
  { label: "Setup MBD", value: "setup-mbd" },
  { label: "Setup DB", value: "setup-db" },
  { label: "Setup BPS Provinsi", value: "setup-bps-province" },
  { label: "Setup BPS Kab/Kota", value: "setup-bps-regency" },
  { label: "Setup BPS Kecamatan", value: "setup-bps-district" },
  { label: "Setup BPS Kelurahan", value: "setup-bps-sub-district" },
  { label: "Setup Area Code", value: "setup-area-code" },
  { label: "Setup Area Cell", value: "setup-area-cell" },
  { label: "Setup Area Mapping", value: "setup-area-mapping" },
  { label: "Setup Cell Code Mapping", value: "setup-cell-code-mapping" },
  { label: "Setup Cell Adj Factor", value: "setup-cell-adj-factor" },
  { label: "Setup Store Panel Cell", value: "setup-store-panel-cell" },
  { label: "Setup Super Category", value: "setup-super-category" },
  { label: "Setup Super Brand", value: "setup-super-brand" },
  { label: "Setup Catalog Report", value: "setup-catalog-report" },
].sort((a, b) => a.label.localeCompare(b.label));

export const roleSuperAdminId = "SA";
export const roleAdminId = "A";
export const roleCoAdminId = "COA";
export const roleTeamLeaderId = "TL";
export const roleSurveyorId = "13";
export const roleQcId = "14";

export const enableFuzzyMatchingFeature = false;
// constant level yang akan terus memiliki 3 level untuk custom chart, custom pivot dan custom tabular
export const LEVEL_OPTION = [
  "1_Category", "3_Brand", "4_Product"
];